/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefundTransactionRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {RefundTransactionResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const refundTransaction = (request: RefundTransactionRequest, options?: CashRequestOptions) => post<RefundTransactionRequest, RefundTransactionResponse>("/2.0/cash/refund-transaction", request, {...options, rejectOnError: true })